import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ap-panel-title',
    templateUrl: './panel-title.component.html',
    styleUrls: ['./panel-title.component.css'],
    standalone: false
})
export class PanelTitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
